export const FIREBASE_CONFIG = {
    apiKey: "AIzaSyCHnc1QwlK88WW6Kg7LjhgtO1pFiTalizI",
    authDomain: "noahmobile-3811d.firebaseapp.com",
    databaseURL: "https://noahmobile-3811d.firebaseio.com",
    projectId: "noahmobile-3811d",
    storageBucket: "noahmobile-3811d.appspot.com",
    messagingSenderId: "114015913632",
    appId: "1:114015913632:web:a78679c2fbbd66e8eaabc5",
    measurementId: "G-31F1RHEB9J"
}